<template>
  <div>
    <div class="text-center mt-2">
      <img width="62px" src="@/assets/logo.png" />
    </div>

    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      ประวัติการแลกคะแนน
    </div>
    <template v-if="!showStatusLog">
      <div v-if="$store.state.redirectview">
        <v-btn
          @click="query.view = $store.state.redirectview"
          text
          color="primary"
        >
          <v-icon>mdi-chevron-left</v-icon>
          กลับ
        </v-btn>
      </div>
      <div v-if="loading" class="text-center mt-7">
        <v-progress-circular indeterminate color="primary" size="60">
        </v-progress-circular>
      </div>
      <div v-else>
        <div class="text-right">
          <v-pagination
            v-if="pagelength > 1"
            :total-visible="4"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
        <v-card v-if="historydata.length" class="elevation-5 mt-4">
          <div
            style="position: relative"
            v-for="(item, k) in historydata"
            :key="k"
            class="pa-2"
          >
            <div
              style="font-size: 12px; position: absolute; right: 4px; top: 3px"
            >
              {{ moment(item.timestamp).format("DD/MM/YYYY HH:mm") }}
            </div>
            <v-row>
              <v-col cols="4">
                <v-img
                  style="border-radius: 5px"
                  aspect-ratio="1"
                  :src="item.productdetail.image"
                ></v-img>
              </v-col>
              <v-col cols="8">
                <div>
                  <div>{{ item.productdetail.name }}</div>
                  <div
                    style="font-size: 20px; line-height: 22px"
                    class="my-1"
                    :class="`${statuscustom(item.status).color}--text`"
                  >
                    {{ statuscustom(item.status).text }}
                  </div>
                  <div>
                    <div style="font-size: 13px">
                      <span class="pr-1">{{ item.nameaddress.address }}</span>
                      <span class="pr-1">
                        {{
                          item.nameaddress.province === "กรุงเทพมหานคร"
                            ? "แขวง"
                            : "ตำบล"
                        }}{{ item.nameaddress.subDistrict }}</span
                      >
                      <span class="pr-1"
                        >{{
                          item.nameaddress.province === "กรุงเทพมหานคร"
                            ? "เขต"
                            : "อำเภอ"
                        }}{{ item.nameaddress.district }}
                      </span>
                      <span class="pr-1"
                        >จังหวัด{{ item.nameaddress.province }}</span
                      >
                      <span>{{ item.nameaddress.postCode }}</span>
                      <br />
                      เบอร์โทรศัพท์ {{ item.nameaddress.phoneNumber }}
                    </div>
                    <div v-if="item.status == 'shipped'" class="primary--text">
                      <div>
                        จัดส่งโดย:
                        <span style="font-weight: bold">
                          {{
                            item.shippingtype
                              ? shippingText[item.shippingtype]
                              : "-"
                          }}
                        </span>
                      </div>
                      <div>
                        เลขพัสดุ:

                        <span style="font-weight: bold">
                          {{ item.trackingno ? item.trackingno : "-" }}
                        </span>
                      </div>
                    </div>
                    <div class="text-center pt-3">
                      <v-btn
                        v-if="item.status !== 'shipped'"
                        @click="
                          editdata = item;
                          showRewardAddress = true;
                        "
                        :disabled="item.status !== 'waiting'"
                        color="primary"
                        small
                      >
                        แก้ไขที่อยู่</v-btn
                      >
                      <v-btn
                        @click="handleShowOrderStatus(item)"
                        color="primary"
                        small
                        class="ml-2"
                        outlined
                      >
                        ตรวจสอบสถานะ</v-btn
                      >
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider v-if="k < historydata.length - 1"></v-divider>
          </div>
        </v-card>
        <div
          v-else
          style="color: darkgrey; font-size: 24px"
          class="mt-7 text-center"
        >
          ยังไม่มีประวัติการแลกของรางวัล
        </div>

        <div>
          <v-dialog v-model="showRewardAddress" fullscreen>
            <v-card v-if="showRewardAddress">
              <RewardAddress
                :editdata="editdata"
                @onsave="onSaveEditAddress"
                @close="showRewardAddress = false"
              ></RewardAddress>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <v-btn @click="showStatusLog = false" text color="primary">
          <v-icon>mdi-chevron-left</v-icon>
          กลับ
        </v-btn>
      </div>
      <OrderStatusLog
        v-if="selectedOrder"
        v-model="selectedOrder"
      ></OrderStatusLog>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RewardAddress from "../RewardAddress.vue";
import OrderStatusLog from "./OrderStatusLog.vue";

export default {
  components: {
    RewardAddress,
    OrderStatusLog,
  },
  data() {
    return {
      editdata: "",
      showRewardAddress: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,

      historydata: [],
      shippingText: {
        flash_charge: "Flash Express",
        nim_charge: "Nim Express",
        ninjavan_charge: "Ninja Van",
        jtexpress_charge: "J&T Express",
        lalamove_charge: "Lalamove",
        cjlogistics_charge: "Cj Logistics",
        nikos_charge: "Nikos Express",
        scgexpress_charge: "SCG Express",
        skootar_charge: "Skootar",
        alphaexpress_charge: "Alpha Express",
        deliveree_charge: "Deliveree",
        grab_charge: "Grab",
        lineman_charge: "Lineman",
        tnt_charge: "TNT Express",
        cod_charge: "เก็บเงินปลายทาง",
        normal_charge: "Thailand Post",
        ems_charge: "EMS",
        kerry_charge: "Kerry Express",
        bestexpress_charge: "BEST Express",
        interexpress_charge: "Inter Express",
        dhl_charge: "DHL",
        other_charge: "ขนส่งรูปแบบอื่น",
        "Kerry Express": "Kerry Express",
      },
      showStatusLog: false,
      selectedOrder: null,
    };
  },
  mounted() {
    this.getOrders();
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit);
      } else {
        return 1;
      }
    },
    moment() {
      return moment;
    },
  },
  methods: {
    onSaveEditAddress() {
      this.showRewardAddress = false;
      this.offset = 0;
      this.pagetmp = 1;
      this.pageNumber = 1;
      this.getOrders();
    },
    changePage(val) {
      var vm = this;
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val;
        vm.offset = vm.pageNumber * this.limit - this.limit;
        if (vm.pageNumber != 1) {
          vm.offset + 1;
        }
        this.getOrders();
      }
    },
    statuscustom(status) {
      if (status == "pending") return { text: "รอการจัดส่ง", color: "orange" };
      else if (status == "waiting")
        return { text: "รอดำเนินการ", color: "grey" };
      else if (status == "shipped")
        return { text: "จัดส่งแล้ว", color: "primary" };
      else if (status == "canceled") return { text: "ยกเลิก", color: "grey" };
      else return { text: status, color: "grey" };
    },
    async getOrders() {
      const vm = this;
      try {
        const data = {
          memberId: vm.$store.state.member.memberId, // required
          limit: vm.limit,
          offset: vm.offset,
          pageid: vm.query.pageid,
        };

        vm.loading = true;
        const url = `${vm.serverUrl}toacrm/history-point-redemtion`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });
        vm.loading = false;

        if (response && response.data.responsecode === 200) {
          vm.historydata = response.data.data.map((el) => {
            const productdetail = JSON.parse(el.productdetail) || {};
            const nameaddress = JSON.parse(el.nameaddress) || {};

            return {
              ...el,
              productdetail,
              nameaddress,
            };
          });
        }
      } catch (error) {
        console.error(error);
        vm.loading = false;
      }
    },
    handleShowOrderStatus(item) {
      const vm = this;
      vm.selectedOrder = item;
      vm.showStatusLog = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
